import Content from './Content';
export type { Props } from './Content';
export default Content;
